import {
    RequestConfigFunction,
} from 'app/types/request.types'

type AdditionalFeesRequests = {
    domainName: string,
    getAllowedFeeNames: RequestConfigFunction<undefined>,
    update: RequestConfigFunction<{id: number}>,
    editableData: RequestConfigFunction<{id: number}>,
    get: RequestConfigFunction<{id: number}>,
    duplicate: RequestConfigFunction<{id: number}>,
    cancellation: RequestConfigFunction<{id: number}>,
    validity: RequestConfigFunction<{id: number}>,
    validation: RequestConfigFunction<{id: number}>,
    archive: RequestConfigFunction<{id: number}>,
    restore: RequestConfigFunction<{id: number}>,
    modifications: RequestConfigFunction<{id: number}>,
}

const additionalFeesRequests: AdditionalFeesRequests = {
    domainName: 'AdditionalFees',
    getAllowedFeeNames: () => {
        return {
            url: 'additionalfees/feename/feechargeability/allowed',
            method: 'GET',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}`,
            method: 'PATCH',
        }
    },
    editableData: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}/editable-data`,
            method: 'PATCH',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}`,
            method: 'GET',
        }
    },
    duplicate: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}/duplication`,
            method: 'POST',
        }
    },
    cancellation: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}/cancellation`,
            method: 'PATCH',
        }
    },
    validity: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}/validity`,
            method: 'PATCH',
        }
    },
    validation: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}/additionalfeesstatus/valid`,
            method: 'PATCH',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}/restore`,
            method: 'PATCH',
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `additionalfees/${id}/modifications`,
            method: 'GET',
        }
    },
}

export default additionalFeesRequests
